import { useMemo } from "react";
import type { TmTask } from "../api/tm";
import { useAssignmentsIndex } from "./useAssignmentsIndex";
import { useUsers, userLabel } from "./useDirectory";
import type { TaskVMExtras } from "../lib/taskVM";

/** Enrichissement des lignes (avatars assignés, compteur sous-tâches, projet)
 * pour les vues denses du design DECO. Sous-tâches comptées depuis
 * l'inventaire déjà chargé (parent_task_id), assignés via l'index batch. */
export function useTaskExtras(tasks: TmTask[] | undefined) {
  const ids = useMemo(
    () => (tasks ?? []).filter((t) => !t.parent_task_id).map((t) => t.id),
    [tasks],
  );
  const assignments = useAssignmentsIndex(ids);
  const users = useUsers();

  return useMemo(() => {
    const subCounts = new Map<string, number>();
    for (const t of tasks ?? []) {
      if (t.parent_task_id) {
        subCounts.set(
          t.parent_task_id,
          (subCounts.get(t.parent_task_id) ?? 0) + 1,
        );
      }
    }
    return (t: TmTask): TaskVMExtras => {
      const asg = (assignments.data?.[t.id] ?? []).filter((a) => a.active);
      const assignees = asg.map((a) => ({
        ref: a.actor_ref,
        name: userLabel(users.data, a.actor_ref),
      }));
      return {
        subtaskCount: subCounts.get(t.id),
        assignees: assignees.length ? assignees : undefined,
        driverName: assignees.find((_, i) => asg[i]?.role === "driver")?.name,
        projectName: t.context_type?.startsWith("pm")
          ? (t.context_label ?? undefined)
          : undefined,
      };
    };
  }, [tasks, assignments.data, users.data]);
}
